module.exports = __webpack_public_path__ + "img/polishing.c276dcc3.jpg";